/* eslint-disable react-hooks/exhaustive-deps */
import AddIcon from "@mui/icons-material/Add";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Box,
    Button,
    FormControl,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useForm } from "src/shared/hooks/useForm";
import { typesVariables } from "src/shared/mocks/variables";
import { useDispatch, useSelector } from "src/stateManagement/redux";
import { config } from "src/stateManagement/redux/configVar";
import {
    createSetPoint,
    editLocationSetPoint,
    updateLocationSetPoint,
} from "src/stateManagement/redux/slices/location/asyncReducers";
import { setPoints } from "src/stateManagement/redux/slices/location/interfaces";
import Swal from "sweetalert2";
import ErrorIcon from '@mui/icons-material/Error';

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

interface Variable {
    id: string;
    name: string;
    type: string;
}

const serverUrl = config.serverUrl;

const DetailsHeader = () => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [setPointsToUpdate, setSetPointsToUpdate] = useState<setPoints[]>([]);
    const [setPointsToDelete, setSetPointsToDelete] = useState<setPoints[]>([]);
    const [variables, setVariables] = useState<Variable[]>([]);
    const [data, setData] = useState<setPoints[]>([]);
    const { locationSetPoints, locationTags, locationId } = useSelector(
        (state) => state.location
    );

    useEffect(() => {
        setData(locationSetPoints);       
    }, [locationSetPoints]);

    useEffect(() => {
        const fetchData = async () => {
            let token = localStorage.getItem("authToken");

            const response = await fetch(
                `${serverUrl}/api/operations/getVariablesList`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `${token}`,
                    },
                }
            );

            const data = await response.json();

            setVariables(Array.isArray(data) ? data : []);
        };
        fetchData();
    }, []);

    const [edit, setEdit] = useState(false);

    const [formValues, handleInputChange, reset] = useForm({
        id: "",
        limit: "",
        value: "",
    });

    const { id, limit, value } = formValues;

    const handleDelete = (id: string, limit: string) => {
        Swal.fire({
            title: "Estas seguro?",
            text: "Quieres eliminar este set point?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "SI, eliminar!",
        }).then((result) => {
            if (result.isConfirmed) {
                const index = locationSetPoints.findIndex(
                    (setPoint) => setPoint.id === id && setPoint.limit === limit
                );

                let newLocationSetPoints = [...locationSetPoints];

                newLocationSetPoints.splice(index, 1);

                const deleteSetPoints = locationSetPoints.find(
                    (setPoint) => setPoint.id === id && setPoint.limit === limit
                );

                if (deleteSetPoints) {
                    setPointsToDelete.push(deleteSetPoints);
                }

                dispatch(editLocationSetPoint(newLocationSetPoints));

                Swal.fire({
                    title: "Eliminado!",
                    icon: "success",
                });
            }
        });
    };

    const handleUpdateSetPoints = () => {
        const data = {
            locationId,
            setPointsToUpdate: setPointsToUpdate,
            setPointsToDelete: setPointsToDelete,
        };

        dispatch(updateLocationSetPoint(data));

        setEdit(!edit);
    };

    const handleEdit = () => {
        setSetPointsToUpdate([]);
        setEdit(!edit);
    };

    const handleOpen = () => {
        setOpen(!open);
    };

    const handleClose = () => {
        setOpen(!open);
    };

    const handleChangeValueSetPoint = (e: any, setPoint: setPoints) => {
        const index = setPointsToUpdate.findIndex(
            (x) => x.id === setPoint.id && x.limit === setPoint.limit
        );
        if (index === -1) {
            setPointsToUpdate.push({
                ...setPoint,
                value: e.target.value,
            });
        } else {
            setPointsToUpdate[index].value = e.target.value;
        }

        const indexData = data.findIndex(
            (x) => x.id === setPoint.id && x.limit === setPoint.limit
        );

        let newData = [...data];

        if (indexData === -1) {
            newData.push({
                ...setPoint,
                value: e.target.value,
            });
        } else {
            newData[indexData] = {
                ...newData[indexData],
                value: e.target.value,
            };
        }
        setData(newData);
    };

    const handleAddSetPoint = () => {
        const title = variables.find((variable: any) => variable.id === id);

        const data = {
            locationId,
            setPoint: {
                id,
                limit,
                value,
                type: title?.name,
                variable: title?.name,
            },
        };

        dispatch(createSetPoint(data));
        setOpen(!open);
    };
    return (
        <Box>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <Accordion
                        elevation={0}
                        defaultExpanded={false}
                        sx={{
                            borderBottom: "1px solid #129ED3",
                        }}
                    >
                        <AccordionSummary
                            expandIcon={<GridExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    width: "100%",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Grid>
                                    <Typography component="span">
                                        Set Points
                                    </Typography>
                                </Grid>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    mb: 2,
                                    width: "100%",
                                    marginTop: "-15px",
                                }}
                            >
                               {data.length === 0 && (
                                    <Grid size={10} sx={{display: 'flex', justifyContent:'flex-start'}} >
                                        <Typography
                                            variant="body2"
                                            color="textSecondary"
                                        >
                                            No hay set points disponibles.
                                        </Typography>
                                    </Grid>
                                )}
                                
                                <Grid size={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    {edit ? (
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            onClick={handleUpdateSetPoints}
                                        >
                                            <SaveAsIcon />
                                        </IconButton>
                                    ) : (
                                        <IconButton
                                            size="small"
                                            color="primary"
                                            onClick={handleEdit}
                                        >
                                            <EditIcon />
                                        </IconButton>
                                    )}

                                    <IconButton
                                        size="small"
                                        color="primary"
                                        onClick={handleOpen}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                </Grid>
                            </Box>
                            <Grid container spacing={2}>
                                {data.length > 0  && (
                                    data?.map(
                                        (setPoint: any, index: number) => {
                                            const tags = locationTags?.find(
                                                (tag: any) =>
                                                    tag.variableId ===
                                                    setPoint.id
                                            );
                                            return (
                                                <Grid
                                                    key={index}
                                                    sx={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                    }}
                                                >
                                                    {tags ? (
                                                        <Tooltip
                                                            title={`${tags.tagName} : ${tags.comment} ${tags?.value}`}
                                                            key={index}
                                                        >
                                                            <TextField
                                                                id="variable"
                                                                size="small"
                                                                label={`${setPoint.variableId}`}
                                                                value={
                                                                    setPoint.value
                                                                }
                                                                sx={{
                                                                    maxWidth:
                                                                        "200px",
                                                                }}
                                                                onChange={(
                                                                    e
                                                                ) => {
                                                                    handleChangeValueSetPoint(
                                                                        e,
                                                                        setPoint
                                                                    );
                                                                }}
                                                                fullWidth
                                                                disabled={!edit}
                                                                key={index}
                                                                slotProps={{
                                                                    input: {
                                                                        endAdornment:
                                                                            (
                                                                                <InputAdornment position="end">
                                                                                    {setPoint.limit.toUpperCase() ===
                                                                                        "UP" && (
                                                                                        <ArrowUpwardIcon />
                                                                                    )}
                                                                                    {setPoint.limit.toUpperCase() ===
                                                                                        "DOWN" && (
                                                                                        <ArrowDownwardIcon />
                                                                                    )}
                                                                                    {setPoint.limit.toUpperCase() ===
                                                                                        "AVERAGE" && (
                                                                                        <HorizontalRuleIcon />
                                                                                    )}
                                                                                    {
                                                                                        <ErrorIcon
                                                                                            fontSize="small"
                                                                                            sx={{
                                                                                                color: "#316EBC",
                                                                                            }}
                                                                                        />
                                                                                    }
                                                                                </InputAdornment>
                                                                            ),
                                                                    },
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    ) : (
                                                        <TextField
                                                            id="variable"
                                                            size="small"
                                                            label={`${setPoint.variableId}`}
                                                            value={
                                                                setPoint.value
                                                            }
                                                            sx={{
                                                                maxWidth:
                                                                    "200px",
                                                            }}
                                                            onChange={(e) => {
                                                                handleChangeValueSetPoint(
                                                                    e,
                                                                    setPoint
                                                                );
                                                            }}
                                                            fullWidth
                                                            disabled={!edit}
                                                            key={index}
                                                            slotProps={{
                                                                input: {
                                                                    endAdornment:
                                                                        (
                                                                            <InputAdornment position="end">
                                                                                {setPoint.limit.toUpperCase() ===
                                                                                    "UP" && (
                                                                                    <ArrowUpwardIcon />
                                                                                )}
                                                                                {setPoint.limit.toUpperCase() ===
                                                                                    "DOWN" && (
                                                                                    <ArrowDownwardIcon />
                                                                                )}
                                                                                {setPoint.limit.toUpperCase() ===
                                                                                    "AVERAGE" && (
                                                                                    <HorizontalRuleIcon />
                                                                                )}
                                                                            </InputAdornment>
                                                                        ),
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                    {edit && (
                                                        <IconButton
                                                            size="small"
                                                            color="error"
                                                            onClick={() =>
                                                                handleDelete(
                                                                    setPoint.id,
                                                                    setPoint.limit
                                                                )
                                                            }
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    )}
                                                </Grid>
                                            );
                                        }
                                    )
                                )}

                                {}
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mb: 2,
                        }}
                    >
                        <IconButton
                            aria-label="delete"
                            onClick={handleClose}
                            sx={{
                                backgroundColor: "#cf1919",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#ff3535",
                                },
                                width: 30,
                                height: 30,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Grid container spacing={2}>
                        <Grid size={12}>
                            <FormControl fullWidth size="small">
                                <Autocomplete
                                    disablePortal
                                    fullWidth
                                    size="medium"
                                    value={
                                        variables
                                            ?.map((v) => ({
                                                id: v.id,
                                                label: v.name,
                                            }))
                                            ?.find(
                                                (v) => v.id === formValues?.id
                                            ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        handleInputChange({
                                            target: {
                                                name: "id",
                                                value: newValue?.id || "",
                                            },
                                        });
                                    }}
                                    options={variables?.map((v) => ({
                                        id: v.id,
                                        label: v.name,
                                    }))}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Tipo de Variable"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid size={12}>
                            <FormControl fullWidth size="small">
                                <InputLabel id="demo-simple-select-label">
                                    Tipo de Limite
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    label="Tipo de Actividad"
                                    id="demo-simple-select"
                                    name="limit"
                                    value={limit}
                                    onChange={handleInputChange}
                                    size="small"
                                >
                                    {typesVariables.map((typeVar, index) => {
                                        const variableValidation =
                                            variables.find(
                                                (v) => v.id === formValues?.id
                                            )?.type || "";

                                        if (
                                            !typeVar.validationType.includes(
                                                variableValidation
                                            )
                                        ) {
                                            return null;
                                        }

                                        return (
                                            <MenuItem
                                                value={typeVar.label}
                                                key={index}
                                            >
                                                {typeVar.label}
                                            </MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid size={12}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Valor"
                                value={value}
                                name="value"
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid size={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                size="small"
                                sx={{ mt: 2 }}
                                onClick={handleAddSetPoint}
                            >
                                Agregar
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </Box>
    );
};

export default DetailsHeader;
